import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { NavigationService } from 'src/app/providers/navigation.service';
import { NewReminderComponent } from '../new-v2-component/new-reminder/new-reminder.component';

@Component({
  selector: 'sm-service-reminder',
  templateUrl: './service-reminder.component.html',
  styleUrls: ['./service-reminder.component.scss']
})
export class ServiceReminderComponent {
  constructor(
    private navservice: NavigationService,private dialog: MatDialog,
   
  ) {
    this.navservice.hideSidebarAndNav = false;


  }


  opennewreminder(){
    this.dialog.open(NewReminderComponent,{
      width:'600px',
      disableClose:true,
  
    })
}
}
